import { useState } from "react";
import { getSiteConfigApi, updateSiteConfigApi } from "../api/siteconfig";
import { useAuth } from "./";

export function useSiteConfig() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [siteConfig, setSiteConfig] = useState(null);
  const { auth } = useAuth();

  const getSiteConfig = async () => {
    try {
      setLoading(true);
      const response = await getSiteConfigApi();
      setLoading(false);
      setSiteConfig(response);
    } catch (error) {
      setLoading(false);
      setError(error);
    }
  };

  const updateSiteConfig = async (data) => {
    try {
      setLoading(true);
      const response = await updateSiteConfigApi(data, auth.token);
      setLoading(false);
      setSiteConfig(response);
    } catch (error) {
      setLoading(false);
      setError(error);
      throw error;
    }
  };

  return {
    loading,
    error,
    siteConfig,
    getSiteConfig,
    updateSiteConfig,
  };
}
